import React from "react"

export const CloseIcon = props => (
  <svg
    width="19px"
    height="19px"
    viewBox="0 0 19 19"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>Close</title>
    <desc />
    <g
      id="Desktop-+-Mobile"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="A10_Mobile-Search-Results"
        transform="translate(-335.000000, -19.000000)"
        stroke="#000000"
      >
        <g id="Close/Black" transform="translate(335.000000, 19.000000)">
          <path
            d="M-3,9.5 L22,9.5"
            id="Stroke-1-Copy"
            transform="translate(9.500000, 9.500000) rotate(-45.000000) translate(-9.500000, -9.500000) "
          />
          <path
            d="M-3,9.5 L22,9.5"
            id="Stroke-1-Copy-2"
            transform="translate(9.500000, 9.500000) rotate(-315.000000) translate(-9.500000, -9.500000) "
          />
        </g>
      </g>
    </g>
  </svg>
)
